<i18n>
{
  "en": {
    "title": "Download what you need",
    "empty": "Empty directory"
  },
  "fr": {
    "title": "Télécharger ce dont vous avez besion",
    "empty": "Le répertoir est vide"
  }
}
</i18n>

<template>
  <div class="docs">
    <h1 class="mdc-typography--headline3" v-if="!hasParent">{{ $t('title') }}</h1>
    <div class="mdc-chip-set">
      <div class="mdc-chip">
        <div class="mdc-chip__text">{{ path }}</div>
      </div>
    </div>
    <ul v-if="files.length === 0" class="mdc-list">
      <li v-if="path !== '/'" @click="$emit('changeDir', clickBack())" class="mdc-list-item">
        <label class="mdc-list-item__text" for="file.Name">..</label>
      </li>
      <li class="mdc-list-item">
        <label class="mdc-list-item__text" for="file.Name">{{ $t('empty') }}</label>
      </li>
    </ul>
    <ul v-else class="mdc-list" v-bind:style="styleOfList">
      <li v-if="path !== '/'" @click="$emit('changeDir', clickBack())" class="mdc-list-item">
        <label class="mdc-list-item__text" for="file.Name">..</label>
      </li>
      <li
        v-for="file in files"
        :key="file.Name"
        @click="$emit('changeDir', clickFile(file, $event))"
        class="mdc-list-item"
      >
        <span class="mdc-list-item__graphic">
          <i v-if="file.IsDir" class="material-icons">folder</i>
          <a
            v-else-if="!hasParent"
            :href="buildURLParameters(file)"
            download
            class="material-icons"
          >cloud_download</a>
        </span>
        <label class="mdc-list-item__text" for="file.Name">
          <span class="mdc-list-item__primary-text">{{ file.Name }}</span>
          <span class="mdc-list-item__secondary-text">{{ file.ModTime }}</span>
        </label>
        <span class="mdc-list-item__meta">
          <span v-if="file.IsDir">---</span>
          <span v-else>{{ file.SizeAsString }}</span>
        </span>
      </li>
    </ul>

    <div class="mdc-snackbar">
      <div class="mdc-snackbar__surface" style="background-color: red;">
        <div
          class="mdc-snackbar__label"
          role="status"
          aria-live="polite"
        >Bad credentials, you are not authorized to visit this area.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { MDCRipple } from '@material/ripple';
import { MDCSnackbar } from '@material/snackbar';
import { MDCList } from '@material/list';

import filesize from 'filesize';
import domParents from 'dom-parents';
import Axios from 'axios';

export default {
  name: 'docs',
  data() {
    return {
      path: '/',
      files: [],
      mdcList: {},

      styleOfList: {},

      tmpToken: '',

      snackbar: {},
    };
  },
  props: ['hasParent'],
  mounted() {
    if (this.$route.params.path !== undefined) {
      this.path = '/' + this.$route.params.path;
    }


    if (this.hasParent) {
      this.styleOfList = {
        'max-height': '400px',
        'overflow-y': 'auto',
      };
    }

    this.snackbar = new MDCSnackbar(document.querySelector('div.docs .mdc-snackbar'));

    this.loadDir(this.path);
  },
  updated() {
    this.$nextTick(() => {
      const mdcList = document.querySelector('div.docs .mdc-list');
      if (mdcList === null) {
        return;
      }

      // Code that will run only after the
      // entire view has been re-rendered
      this.mdcList = new MDCList(mdcList);

      this.$el.querySelectorAll('li').forEach((element) => {
        return new MDCRipple(element);
      });
    });
  },
  destoyed() {
    this.snackbar.destroy();
    this.mdcList.destroy();
  },
  methods: {
    loadDir(dir) {
      const vue = this;
      Axios.post(
        '/API/getPath',
        { Path: dir },
      )
        .then((resp) => {
          this.path = dir;
          this.tmpToken = resp.data.TmpToken;
          for (const file of resp.data.Files) {
            file.SizeAsString = filesize(file.Size);
          }
          this.files = resp.data.Files;

          if (!this.hasParent) {
            vue.$router.replace('/docs' + this.path);
          }
        }).catch(() => {
          this.snackbar.open();
        });
    },
    clickFile(file, ev) {
      let path = '';
      if (this.path !== '/') {
        path = this.path;
      }
      const filePath = path + '/' + file.Name;

      if (file.IsDir) {
        this.loadDir(filePath);
      } else if (!this.hasParent) {
        domParents(ev.currentTarget, 'li', true)[0]
          .querySelector('a').click();
      }
      return filePath;
    },
    clickBack() {
      const parentDirs = this.path.split('/');
      parentDirs.pop();

      let parentDirPath = parentDirs.join('/');
      if (parentDirPath === '') {
        parentDirPath = '/';
      }

      this.loadDir(parentDirPath);

      return parentDirPath;
    },
    buildURLParameters(file) {
      const url = new URL(
        '/API/dlFile/' + file.Name,
        document.location.protocol + '//' + document.location.host,
      );

      url.searchParams.append('path', this.path);
      url.searchParams.append('token', this.tmpToken);
      return url.toString();
    },
  },
};
</script>
